// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2LWdH","list":"PatternAutocomplete_list__2iDic"};